import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { SiteDto } from '@lib/dto/site.dto'
import { clientService } from '@/services/ClientService'
import { siteKeys } from '@/hooks/queryKeys'

/**
 * One site, for screens reached by a deep link that have only its id.
 *
 * `retry: false` because its main consumer is the survey screen, which works
 * offline: failing once and falling back to a generic heading beats retrying
 * into a dead radio.
 */
export function useSite(siteId: string): UseQueryResult<SiteDto> {
  return useQuery({
    queryKey: siteKeys.detail(siteId),
    queryFn: () => clientService.getSite(siteId),
    enabled: siteId !== '',
    retry: false,
    staleTime: 60_000,
  })
}
